module.exports = __webpack_public_path__ + "static/media/1-Exterior_200227125056.28a1dae7.jpg";